import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { Conversation } from '../conversation.js';

/**
 * Löscht alle Konversationen einer Guest-User-ID aus der Datenbank.
 * Dies wird aufgerufen, wenn ein Gast die Seite schließt oder aktualisiert.
 */
export const cleanupGuestDataMutation = registerMutation({
  operationName: 'cleanupGuestData',
  type: () => Boolean,
  params: [{ name: 'guestUserID', type: () => String }],
  resolve: (guestUserID: string) => async () => {
    // Validiere, dass es eine Guest-User-ID ist
    if (!guestUserID.startsWith('guest:')) {
      logger.warn({ guestUserID, context: 'cleanup-guest-data' }, 'Invalid guest user ID');
      return false;
    }

    try {
      const conversationCollection = await getCollection(Conversation);

      // Lösche alle Konversationen mit dieser Guest-User-ID
      const result = await conversationCollection.deleteMany({ userID: guestUserID });

      if (result.deletedCount > 0) {
        logger.info({ deletedCount: result.deletedCount, guestUserID, context: 'cleanup-guest-data' }, 'Deleted conversations for guest');
      }

      return true;
    } catch (error) {
      logger.error({ err: error, guestUserID, context: 'cleanup-guest-data' }, 'Error cleaning up guest data');
      return false;
    }
  },
});
